import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of, BehaviorSubject} from 'rxjs';
import {AppConfigService} from './app-config.service';
import {ApiUrlConstants} from '../../shared/utils/api-constants';
import {DashboardMetrics} from '../../shared/models/dashboard-metrics';
import {AppHttpParams} from '../../shared/models/app-http-params';
import { DashboardTrends } from '../../shared/models/dashboard-trends';
import { shareReplay, tap, catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  private metricsSubject$ = new BehaviorSubject<DashboardMetrics | null>(null);
  public metrics$ = this.metricsSubject$.asObservable();
  private metricsRequest$: Observable<DashboardMetrics> | null = null;

  constructor(private http: HttpClient, private authService: AuthService) {
  }

  getMetrics(): Observable<DashboardMetrics> {
    if (!this.metricsRequest$) {
      const appParams = new AppHttpParams({responseLabel: 'dashboard', notifyError: true});
      this.metricsRequest$ = this.http.get<DashboardMetrics>(AppConfigService.eoApiUrl + ApiUrlConstants.DASHBOARD_METRICS, {params: appParams}).pipe(
        tap(metrics => this.metricsSubject$.next(metrics)),
        shareReplay(1),
        catchError(err => {
          this.metricsRequest$ = null; 
          throw err;
        })
      );
      
      setTimeout(() => { this.metricsRequest$ = null; }, 30000);
    }
    return this.metricsRequest$;
  }

  refreshMetrics(): void {
    this.metricsRequest$ = null;
    this.getMetrics().subscribe();
  }

  getTrends(filters?: any): Observable<DashboardTrends> {
    const params: any = {};
    if (filters) {
      if (filters.eoId && filters.eoId.length > 0) {
        params.eoId = filters.eoId.join(',');
      }
      if (filters.productDomain && filters.productDomain.length > 0) {
        params.productDomain = filters.productDomain.join(',');
      }
      if (filters.productType && filters.productType.length > 0) {
        params.productType = filters.productType.join(',');
      }
      if (filters.facility) {
        params.facility = filters.facility;
      }
      if (filters.date) {
        params.date = filters.date;
      }
      if (filters.eoName) {
        params.eoName = filters.eoName;
      }
    }

    const preferredCurrency = this.authService.user?.Preferred_Currency || 'EUR';
    params.preferredCurrency = preferredCurrency;

    const appParams = new AppHttpParams({params, responseLabel: 'dashboard', notifyError: true});
    const url = AppConfigService.orderApiUrl + AppConfigService.settings.apiServer.apiVersion + '/dashboard/trends';
    return this.http.get<DashboardTrends>(url, {params: appParams});
  }

}
